import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { i } from 'mathjs';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class AirtableEditPage extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    collectionsByAirtable: [],
    collectionsByexternaldb: [],
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    await actions.loadExternalDatabaseForAirtable({ projectId, externalDbUuid, version });
    await actions.collectionListExternaldbs({ projectId, dbUuid: externalDbUuid, version });
    const { externalDbAirtable, collectionList } = this.props.dataConnector;
    const { completeData } = externalDbAirtable;
    this.setState({ collectionsByAirtable: completeData.tables });
    this.setState({ collectionsByexternaldb: collectionList });
  }
  handleCreateCollection = (index) => {
    const { match, history } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    history.push(
      `/2.0/data-connector/${version}/v/${projectId}/airtable-datasource/${externalDbUuid}/create`,
      {
        collectionIndex: index,
      },
    );
  };
  handleUpdateCollection = (item) => {
    const { match, history } = this.props;
    const { projectId, externalDbUuid, version } = match.params;
    history.push(
      `/2.0/data-connector/${version}/v/${projectId}/airtable-edit/${externalDbUuid}/update/${item.collectionId}`,
    );
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { collectionsByAirtable, collectionsByexternaldb } = this.state;
    const collectionsWithDb = collectionsByexternaldb.map((a) => a.collectionTitle);
    return (
      collectionsByAirtable && (
        <CommonPageComponent>
          <ParentContentCard title={'All Collections in  Airtable Database'} icon={'collection'}>
            <div className="grid__column">
              {collectionsByAirtable.map((item, index) => (
                <span
                  className={`card card--user-profile ml-4 card--collection-source`}
                  key={index}
                >
                  <div className="card-body">
                    <div className="avatar__meta">
                      <h5 className="avatar__title js-user-name" title={item.collectionName}>
                        {item.collectionName}
                      </h5>
                      {collectionsWithDb.includes(item.collectionName) ? (
                        <button
                          className="btn btn-theme-submit btn-md"
                          onClick={() => this.handleUpdateCollection(item)}
                        >
                          <i className="wb webconnect-save-regular"> </i>
                          {' Update'}
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary btn-md"
                          onClick={() => this.handleCreateCollection(index)}
                        >
                          <i className="wb webconnect-plus"> </i>
                          {' Create'}
                        </button>
                      )}
                    </div>
                  </div>
                </span>
              ))}
            </div>
          </ParentContentCard>
        </CommonPageComponent>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AirtableEditPage);
